import React, { useState } from "react";
import TitleStripe from "../../common/TitleStripe";
import { Alert } from "flowbite-react";
import Enderecos from "../../common/query/Enderecos";
import NoOcurrence from "../../common/query/NoOcurrence";
import Emails from "../../common/query/Emails";
import Telefones from "../../common/query/Telefones";
import TitleStripe2 from "../../common/TitleStripe2";

const CNDT = ({ data }) => {
  return (
    <div>
      {data?.cndt?.statusRetorno == 1 ? (
        <div>
          {!data?.localizacao && (
            <div>
              <div>
                <TitleStripe>Endereços</TitleStripe>
                {data?.cndt?.enderecos?.length > 0 ? (
                  <Enderecos enderecos={data?.cndt?.enderecos} />
                ) : (
                  <NoOcurrence />
                )}
              </div>
              <div>
                <TitleStripe>E-mails</TitleStripe>
                {data?.cndt?.emails?.length > 0 ? (
                  <Emails emails={data?.cndt?.emails} />
                ) : (
                  <NoOcurrence />
                )}
              </div>
              <div>
                <TitleStripe>Telefones</TitleStripe>
                {data?.cndt?.telefones?.length > 0 ? (
                  <Telefones telefones={data?.cndt?.telefones} />
                ) : (
                  <NoOcurrence />
                )}
              </div>
            </div>
          )}

          <TitleStripe2 className="mt-4">
            📄 Certidão negativa de débitos trabalhistas
          </TitleStripe2>
          <div className="flex items-start gap-4 mt-5">
            {data?.cndt?.cndt?.certidao?.imageFile?.FILE_BASE64 && (
              <img
                className="max-w-md overflow-hidden border border-gray-200 rounded-md"
                src={`data:image/png;base64, ${data?.cndt?.cndt?.certidao?.imageFile?.FILE_BASE64}`}
              />
            )}
            <div>
              <div className="mb-2">
                <span className="font-semibold inline-block mr-1">Nome:</span>
                {data?.cndt?.cndt?.nome || "Não informado"}
              </div>
              <div className="mb-2">
                <span className="font-semibold inline-block mr-1">
                  Documento:
                </span>
                {data?.cndt?.cndt?.documento || "Não informado"}
              </div>
              <div className="mb-2">
                <span className="font-semibold inline-block mr-1">
                  Data de emissão:
                </span>
                {data?.cndt?.cndt?.emissao || "Não informado"}
              </div>
              <div className="mb-2">
                <span className="font-semibold inline-block mr-1">
                  Data de expedição:
                </span>
                {data?.cndt?.cndt?.expedicao || "Não informado"}
              </div>
              <div className="mb-2">
                <span className="font-semibold inline-block mr-1">
                  Data de validade:
                </span>
                {data?.cndt?.cndt?.validade || "Não informado"}
              </div>
              <div className="mb-2">
                <span className="font-semibold inline-block mr-1">
                  Cod. da certidão:
                </span>
                {data?.cndt?.cndt?.codCertidao || "Não informado"}
              </div>
              <div className="mb-2">
                <span className="font-semibold inline-block mr-1">
                  Mensagem:
                </span>
                {data?.cndt?.cndt?.mensagem || "Não informado"}
              </div>
              <div className="mb-2">
                <span className="font-semibold inline-block mr-1">
                  Emitiu certidão negativa:
                </span>
                {data?.cndt?.cndt?.emitiuCertidaoNegativa || "Não informado"}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <TitleStripe>Certidão negativa de débitos trabalhistas</TitleStripe>
          <Alert withBorderAccent color="gray" className="mt-5">
            Consulta Indisponível no momento
          </Alert>
        </div>
      )}
    </div>
  );
};

export default CNDT;
